import { segmentBlobs } from '../blobSegmenter'

// Live object counting for the /vision play surface — the same blob segmenter
// used in AI Studio Execute: threshold the high-contrast scene (dark parts on a
// light background), group connected pixels, filter by area/edge, and count.
// Draws a numbered marker per part and shows the running count. Throttled since
// segmenting a full frame is moderately heavy.
export default function createPartCountDetector() {
    let canvas = null
    let lastAt = 0
    let cached = { boxes: [], count: 0 }

    const grab = (video, vw, vh) => {
        const W = Math.min(640, vw)
        const H = Math.round((W * vh) / vw)
        if (!canvas) canvas = document.createElement('canvas')
        if (canvas.width !== W) canvas.width = W
        if (canvas.height !== H) canvas.height = H
        const ctx = canvas.getContext('2d', { willReadFrequently: true })
        ctx.drawImage(video, 0, 0, W, H)
        return ctx.getImageData(0, 0, W, H)
    }

    const build = (count, boxes) => ({
        boxes,
        title: 'Object Count',
        insights: [{ label: 'Count', value: count }],
    })

    return {
        id: 'count',
        label: 'Object Count',
        accent: '#22b8cf',

        async load() {},

        async detect({ video, vw, vh }) {
            if (!vw || !vh) return build(cached.count, cached.boxes)
            const now = performance.now()
            if (now - lastAt < 150)
                return build(cached.count, cached.boxes)
            lastAt = now
            const img = grab(video, vw, vh)
            const blobs = segmentBlobs(img, {
                threshold: 0.4,
                minAreaFrac: 0.0004,
                maxAreaFrac: 0.15,
            })
            const boxes = blobs.map((b, i) => ({
                x: b.x,
                y: b.y,
                w: b.w,
                h: b.h,
                label: `${i + 1}`,
                score: 1,
            }))
            cached = { boxes, count: blobs.length }
            return build(blobs.length, boxes)
        },

        reset() {
            cached = { boxes: [], count: 0 }
            lastAt = 0
        },
        dispose() {
            canvas = null
        },
    }
}
